export const ARTICLE_LOAD_REQUEST = 'ARTICLE_LOAD_REQUEST';
export const ARTICLE_LOAD_SUCCESS = 'ARTICLE_LOAD_SUCCESS';
export const ARTICLE_LOAD_FAILURE = 'ARTICLE_LOAD_FAILURE';
